module.exports = __webpack_public_path__ + "img/2.4771be5a.jpg";